import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-end overflow-hidden" data-id="element-118">
      {/* Full background image */}
      <div className="absolute inset-0" data-id="element-119">
        <img src="https://cdn.magicpatterns.com/uploads/4zuFgxqeJGTfJbGAGihKpG/PIC_2.png" alt="Elizabeth Guzmán with community members" className="w-full h-full object-cover object-top scale-[0.85] origin-top" data-id="element-120" />
        {/* Dark overlay gradient — heavier at bottom for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/30" data-id="element-121" />
        <div className="absolute inset-0 bg-navy/20" data-id="element-122" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full relative z-10 pb-20 md:pb-28 pt-48 md:pt-56" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-124">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white leading-[1.1] mb-6 drop-shadow-lg" data-id="element-125">
            Fighting for <br data-id="element-126" />
            <span className="text-red italic" data-id="element-127">Working Families.</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl leading-relaxed mb-10 font-light drop-shadow-md" data-id="element-128">
            Bringing a working-class, immigrant perspective to Congress. Because
            the American Dream should be accessible to everyone, not just the
            privileged few.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-129">
            <a href="/volunteer" className="bg-red hover:bg-red-light text-white font-bold text-sm tracking-widest uppercase px-8 py-4 rounded-sm transition-colors flex items-center justify-center gap-2 group shadow-lg" data-id="element-130">
              Join the Movement
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-131" />
            </a>
            <a href="https://secure.actblue.com/donate/guzman_va_web" target="_blank" rel="noopener noreferrer" className="bg-white/10 backdrop-blur-sm border border-white/30 hover:border-white hover:bg-white/20 text-white font-bold text-sm tracking-widest uppercase px-8 py-4 rounded-sm transition-colors flex items-center justify-center shadow-lg" data-id="element-132">
              Donate Now
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}